<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'/master/phase/'"
    [isDeletable]="'/master/phase-master' | hasPermission: 'Delete'"  [showAddButton]="'/master/phase-master' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/phase-master' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/phase-master' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>

<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="addDialogConfig"
  [initialData]="{}"
  [viewMode]="false"
  (onSubmit)="onSubmitAdd($event)"
  (onCancel)="onCancelAdd()"
  (onClose)="onCloseAdd()"
></app-reusable-dialog>


<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="selectedPhaseData"
  [viewMode]="viewMode"
  (onSubmit)="onSubmitUpdate($event)"
  (onCancel)="onCancelUpdate()"
  (onClose)="onCloseUpdate()"
></app-reusable-dialog>

<p-dialog header="Delete Phase" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete phase ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>